import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import localeSv from '@angular/common/locales/sv';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { applicationConfig } from 'app/app.config';
import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';

import { provideServiceWorker } from '@angular/service-worker';

// Sentry.init({
//     dsn: environment.sentry.dsn,
//     integrations: [Sentry.browserTracingIntegration()],
//     tracesSampleRate: environment.production ? 0.1 : 1.0,
//     tracePropagationTargets: ['localhost', /^https:\/\/sentry\.appbolaget\.dev\/api/],
//     beforeSend: awareSentryBeforeSend,
// });

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    ...applicationConfig,
    providers: [
        provideZoneChangeDetection(),
        ...applicationConfig.providers,
        provideServiceWorker('ngsw-worker.js', {
            enabled: !environment.local,
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
}).catch((err) => console.log(err));

registerLocaleData(localeSv);
